'use strict';

angular.module('webAgro1App').filter('average', function() {
  return function(items, field) {
    if (!items || !field) {
      return;
    }

    return items.reduce(function(result, item) {
      var value = +_.get(item, field);
      return result + value;
    }, 0) / items.length;
  };
});
